<template>
  <v-card outlined :class="[{ 'other-unit-card': isOtherUnit }]">
    <!-- Unit Header -->
    <unit-header
      :unit="unit"
      :show-details="showDetails"
      @toggle-details="showDetails = !showDetails"
    />

    <v-divider></v-divider>

    <!-- Crew Combinations Summary -->
    <crew-combinations-summary :crew-combinations="unit.crewCombinations" />

    <v-divider v-if="showDetails"></v-divider>

    <!-- Detailed Information with Tabs -->
    <crew-combination-details
      v-if="showDetails"
      :crew-combinations="unit.crewCombinations"
      :show-suggestions="showSuggestions"
      @suggestion-action="handleSuggestionAction"
    />
  </v-card>
</template>

<script>
import UnitHeader from "./UnitHeader.vue";
import CrewCombinationsSummary from "./CrewCombinationsSummary.vue";
import CrewCombinationDetails from "./CrewCombinationDetails.vue";

export default {
  name: "UnitForecastCard",
  components: {
    UnitHeader,
    CrewCombinationsSummary,
    CrewCombinationDetails,
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    isOtherUnit: {
      type: Boolean,
      default: false,
    },
    showSuggestions: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    selectedCrewCombination() {
      return this.unit.crewCombinations?.find((cc) => cc.isSelected) || null;
    },
  },
  methods: {
    handleSuggestionAction(suggestion) {
      this.$emit("suggestionAction", {
        unit: this.unit,
        action: suggestion.action,
        suggestion,
      });
    },
  },
};
</script>

<style scoped>
.other-unit-card {
  border-style: dashed !important;
}
</style>
